import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  elementStyle: {
    marginLeft: "-15px",
    "& svg": {
      height: "24px",
    },
    // color: props => `${props.currentTheme.primaryColor} !important`,
  },
  globalTech: {
    color: "#041f41 !important",
  },
  walmartClassic: {
    color: "#0071ce !important",
  },
  samClub: {
    color: "#0266A0 !important",
  },
  elementStyleNotSelected: {
    marginLeft: "-15px",
    "& svg": {
      height: "24px",
    },
    color: `#5E5E5E !important`,
  },
  radios: {
    maxWidth: 700,
  },
  radio: {
    marginTop: "16px",
    display: "flex",
    alignItems: "center",
  },
  halfColumnWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  halfColumn: {
    display: "flex",
    alignItems: "center",
    width: "40%",
  },
  radioText: {
    display: "inline-block",
    verticalAlign: "-2px",
    cursor: "pointer",
    width: "90%",
    maxWidth: 650,
    wordWrap: "break-word",
    fontSize: 16,
  },
  helperTextRow: {
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    maxWidth: 700,
    marginTop: 10,
  },
  otherTextField: {
    marginLeft: "34px !important",
  },
  itemGap: {
    marginTop: "14px",
  },
  other: {
    width: "40%",
  },
});

export default useStyles;
